import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import GUI from 'lil-gui'

import { FontLoader } from 'three/examples/jsm/loaders/FontLoader.js'
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry.js'

//cimport typefaceFont from '/fonts/helvetiker_regular.typeface.json'

/**
 * Base
 */
// Debug
//const gui = new GUI()

/**
 * Textures
 */
const textureLdr = new THREE.TextureLoader();
const matcapTexture = textureLdr.load('/textures/matcaps/8.png')
matcapTexture.colorSpace = THREE.SRGBColorSpace
console.log(matcapTexture)

const textMaterial = new THREE.MeshMatcapMaterial({matcap:matcapTexture}) 

/**
 * Fonts
 */
const fontLoader = new FontLoader()
let diceBox;
let font_loaded = false;

fontLoader.load(
    '/fonts/helvetiker_regular.typeface.json',
    (font) =>
    {
        //console.log('font loaded')
        const textGeomObj = new TextGeometry (
        "They see me rolling...",
            {    
                font: font,
                size: 0.5,
                depth: 0.2,
                curveSegments: 12,
                bevelEnabled: true,
                bevelThickness: 0.03,
                bevelSize: 0.02,
                bevelOffset: 0,
                bevelSegments: 5
            }
         )



        //  const textMaterial = new THREE.MeshBasicMaterial()
         
        const text = new THREE.Mesh(textGeomObj, textMaterial)
        textGeomObj.computeBoundingBox()
        console.log(textGeomObj.boundingBox)
        diceBox = textGeomObj.boundingBox
        //console.log(diceBox)
        textGeomObj.translate(
        - (textGeomObj.boundingBox.max.x - 0.02) * 0.5, // Subtract bevel size
        - (textGeomObj.boundingBox.max.y - 0.02) * 0.5, // Subtract bevel size
        - (textGeomObj.boundingBox.max.z - 0.03) * 0.5  // Subtract bevel thickness
        )   
        
        scene.add(text)
        font_loaded = true;
        //console.log(font_loaded)
            
    }
)

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

/**
 * Textures
 */
const textureLoader = new THREE.TextureLoader()

/**
 * Object
 */

        // const donutGeometry = new THREE.TorusGeometry(0.3, 0.2, 20, 45)
        // const donutMaterial = new THREE.MeshMatcapMaterial({ matcap: matcapTexture })
        // for(let i = 0; i < 100; i++)
        // {
        //     const donut = new THREE.Mesh(donutGeometry, donutMaterial)
        //     donut.position.x = (Math.random() - 0.5) * 10
        //     donut.position.y = (Math.random() - 0.5) * 10
        //     donut.position.z = (Math.random() - 0.5) * 10
        //     donut.rotation.x = Math.random() * Math.PI
        //     donut.rotation.y = Math.random() * Math.PI
        //     var bbox = new THREE.Box3().setFromObject(donut);
        //     //donut.donutGeometry.computeBoundingBox()
        //     if (!textGeomObj.boundingBox.intersectsBox(bbox)) {
        //         scene.add(donut)
        //     }
        //     scene.add(donut)
        // }

    const poly = new THREE.IcosahedronGeometry()
    const donutMaterial = new THREE.MeshMatcapMaterial({ matcap: matcapTexture })

    // const waitUntilReady = new Promise(font_loaded);
    // waitUntilReady.then(doSomething);










// const cube = new THREE.Mesh(
//     new THREE.BoxGeometry(1, 1, 1),
//     new THREE.MeshBasicMaterial()
// )

// const donutGeometry = new THREE.TorusGeometry(0.3, 0.2, 20, 45)
// const donutMaterial = new THREE.MeshMatcapMaterial({ matcap: matcapTexture })
// const donut = new THREE.Mesh(donutGeometry, donutMaterial)


// for(let i = 0; i < 100; i++)
// {
//     donut.position.x = (Math.random() - 0.5) * 10
//     donut.position.y = (Math.random() - 0.5) * 10
//     donut.position.z = (Math.random() - 0.5) * 10
//     donut.rotation.x = Math.random() * Math.PI
//     donut.rotation.y = Math.random() * Math.PI
    
//     scene.add(donut)
// }



//const text = new THREE.
//scene.add(cube)
/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
camera.position.x = -1
camera.position.y = 1
camera.position.z = 4
scene.add(camera)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

/**
 * Animate
 */
const clock = new THREE.Clock()

let cubes_added = false
const dicegroup = new THREE.Group()


const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()

    // Update controls

    // Render
    if (font_loaded && !cubes_added){
        console.log(diceBox)

        for(let i = 0; i < 100; i++)
        {
            const donut = new THREE.Mesh(poly, donutMaterial)
            donut.position.x = (Math.random() - 0.5) * 10
            donut.position.y = (Math.random() - 0.5) * 10
            donut.position.z = (Math.random() - 0.5) * 10
            donut.rotation.x = Math.random() * Math.PI
            donut.rotation.y = Math.random() * Math.PI
            var bbox = new THREE.Box3().setFromObject(donut);
            //donut.donutGeometry.computeBoundingBox()
            
            if (!(bbox.intersectsBox(diceBox))) {
                const scale = Math.random()
                donut.scale.set(scale, scale, scale)
                //scene.add(donut)
                dicegroup.add(donut)

                //console.log("Added die xy")
            }
            // scene.add(donut)
            //console.log(i)
        }
        console.log("Done...")
        console.log(dicegroup)
        scene.add(dicegroup)
        cubes_added = true
        //console.log(dicegroup.children[1])
        console.log(dicegroup.children.length)

    }
    //console.log(cubes_added)
    if(cubes_added) {

        for(let i = 0; i < 25; i++)
        {
            dicegroup.children[i].rotation.x += Math.PI *0.007
        }
        for(let i = 25; i < 50; i++)
        {
            dicegroup.children[i].rotation.x += Math.PI *0.007
        }
        for(let i = 50; i < dicegroup.children.length; i++)
        {
            dicegroup.children[i].rotation.y += Math.PI *0.007
        }
        // dicegroup.children[0].rotation.x += Math.PI *0.007
        // dicegroup.children[3].rotation.x += Math.PI *0.007
        // dicegroup.children[5].rotation.x += Math.PI *0.007
        // dicegroup.children[10].rotation.x += Math.PI *0.007


       // dicegroup.rotation.z += Math.PI *0.001 
        
     }
    controls.update()
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()